import { render, staticRenderFns } from "./SuperAdminSidebar.vue?vue&type=template&id=71c75204"
import script from "./SuperAdminSidebar.vue?vue&type=script&lang=js"
export * from "./SuperAdminSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c75204')) {
      api.createRecord('71c75204', component.options)
    } else {
      api.reload('71c75204', component.options)
    }
    module.hot.accept("./SuperAdminSidebar.vue?vue&type=template&id=71c75204", function () {
      api.rerender('71c75204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/partials/SuperAdminSidebar.vue"
export default component.exports